module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "arrow"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 3000 200"
    }
  }, [_c('defs', [_c('marker', {
    attrs: {
      "id": "arrowhead",
      "markerWidth": "10",
      "markerHeight": "6",
      "refX": "0",
      "refY": "3.5",
      "orient": "auto",
      "stroke": this.color,
      "fill": this.color
    }
  }, [_c('polygon', {
    attrs: {
      "points": "0 1.8, 5 3.5, 0 5"
    }
  })])]), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "0",
      "y1": "95",
      "x2": "10%",
      "y2": "95",
      "stroke": this.color,
      "stroke-width": "35",
      "marker-end": "url(#arrowhead)"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.name))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b76b952"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/ArrowRight.vue
// module id = 74
// module chunks = 0